export interface LanguageOption {
    localisationOrganisationId: number
    languageId: number
	enabled: boolean
	name: string
	languageCode: string
	translationStatus: 0 | 1 | 2 | 3
    previousTranslationExists: boolean
    flagRegionCode: string
}

export interface LanguageOptionsReq {
    languageOptions: LanguageOption[]
	succesfullyTranslated: number
    languageOptionsTotal: number
}

export enum TranslatedStatus {
    Initialise = 0,
    Translating = 1,
    Success = 2,
    Failed = 3
}

export interface LanguageOptionResource {
    LocalisationOrganisationId: number
    LanguageId: number;
    LanguageCode: string;
    Name: string;
    TranslationStatus: TranslatedStatus
    Enabled: boolean;
}